import React from 'react'
import { Navigate } from 'react-router-dom'
import Form from './form';
import { firstAllowedPath } from '../../../configTools/permissions';

// Login page, on the new design system (Task 11). This page is the entrance to the working
// tool the business runs on, so every branch below is presentation-only: same four role
// redirects (admin/labadmin/doctor/anything-else), same firstAllowedPath() employee branch
// with the same /signout link, same `?expired=1` query-param check and message. Nothing in
// this file's conditionals, redirect targets or localStorage read changed - only the JSX
// each branch returns and the old css/public/pages/login.css import (dropped; the file
// itself is left in place unreferenced, same pattern the other rebuilt public pages use).
const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    if(User){
        if(User.role === 'admin'){
            return <Navigate to={'/admin'}/>
        }
        else if(User.role === 'labadmin'){
            return <Navigate to={"/labadmin"}/>
        }
        else if(User.role === 'doctor'){
            return <Navigate to={"/doctor"}/>
        }
        else if(User.role === 'employee'){
            // Straight to the first page they are allowed to open. '/labadmin' would redirect to
            // the dashboard, which most employees will not have, bouncing them back here.
            const landing = firstAllowedPath(User);
            if(landing){
                return <Navigate to={landing}/>
            }
            // Signed in but granted nothing. Showing the form again would look like the password
            // was wrong, so say what actually happened. Styled as a deliberate empty state (a
            // normal situation for a freshly created account), not an error page.
            return (
                <section className="section login-section">
                    <div className="container login-shell">
                        <div className="login-card login-empty-state">
                            <h1 className="login-empty-title">Your account does not have access to any pages yet.</h1>
                            <p className="login-empty-sub">
                                Ask your lab administrator to grant access, then sign in again.
                            </p>
                            <p className="login-empty-action">
                                <a href='/signout'>Sign out</a>
                            </p>
                        </div>
                    </div>
                </section>
            );
        }
        else{
            return <Navigate to={"/"}/>
        }
    }
    else{
        // authGuard.js appends this when the API refuses the stored session. Without a word of
        // explanation an automatic sign-out looks like the app crashed or logged them off at
        // random; this says it was deliberate and what to do next.
        const expired = window.location.search.indexOf('expired=1') !== -1;
        return (
          <section className="section login-section">
            <div className="container login-shell">
              {expired &&
                  <p className="login-notice" role="status">
                      Your session has ended. Please sign in again.
                  </p>
              }
              <Form/>
            </div>
          </section>
        )
    }
}

export default Index
